import React, { useContext } from 'react';
import Slider from 'react-slick';
import { LandingPageData } from '../../contexts/LandingPageContext';
import { CategoryBox, Settings } from './CategoryItems';
import NoDataAvailable from '../NoDataAvailable';

export default function category() {
  const { data: { cats: CategoryItems, isLoading } } = useContext(LandingPageData);
  const isAvailable = Boolean(CategoryItems.length);

  return (
    <div className="bg-white">
      <div className="flex justify-center mt-10 pt-10">
        <h1 className="font-bold font-italic font-serif text-main uppercase">New and Used Medical Equipment</h1>
      </div>
      {isAvailable && !isLoading && (
        <>
          <Slider {...Settings}> {/* eslint-disable-line */}
            { CategoryItems.map((value) => (
              <CategoryBox id={value.id} name={value.name} imageURL={value.img} key={`${value.id}${value.name}`} />
            )) }
          </Slider>
          <div className="flex justify-center mt-1 ml-5 xs:hidden md:flex">
            <button type="button" className="px-5 py-3 font-semibold my-5 border hover:rounded-md hover:bg-gray-200 bg-white text-main uppercase">
              See All category
            </button>
          </div>
        </>
      )}
      {!isAvailable && !isLoading && (
        <div className="flex justify-center items-center bg-white border-2 rounded-lg min-h-[200px]">
          <NoDataAvailable />
        </div>
      )}
    </div>
  );
}
